module.exports = __webpack_public_path__ + "static/media/nft-1.40b78169.png";